import { BaseService } from '@absg/nim-client-shared';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CmsService extends BaseService {
  private cmsUrl: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private isFailedState: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  cmsUrl$ = this.cmsUrl.asObservable();
  isFailedState$ = this.isFailedState.asObservable();
  constructor() {
    super();
  }

  setCmsURl(url: string): void {
    this.isFailedState.next(false);
    this.cmsUrl.next(url);
  }

  setFailedState(value: boolean): void {
    this.isFailedState.next(value);
  }
}
